export const FormModes = {
    ADD: 'ADD',
    EDIT: 'EDIT',
};

export const MessageTemplateMode = {
    LIST: 'LIST',
    CREATE: 'CREATE',
    EDIT: 'EDIT'
};